export const PATIENT_FILE_KEYS = {
  all: ['patient-file'] as const,
  byUser: (userid: string | number) => [...PATIENT_FILE_KEYS.all, String(userid)] as const,
} as const;
